import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { QuestionMarkCircleIcon, HomeIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";

export default function LinkNotFound() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get("code") || "";
  const reason = searchParams.get("reason") || "not_found";

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-100 to-indigo-50 dark:from-gray-900 dark:via-gray-850 dark:to-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-3xl shadow-2xl border border-gray-100 dark:border-gray-750 p-8 sm:p-10 text-center relative overflow-hidden">
        {/* Subtle decorative glow */}
        <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-blue-500/20 blur-3xl pointer-events-none" />

        {/* 404 Badge */}
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-blue-50 dark:bg-blue-950/50 text-[#3a57e8] dark:text-blue-400 border border-blue-100 dark:border-blue-900 shadow-lg mb-6">
          <QuestionMarkCircleIcon className="w-10 h-10" />
        </div>

        {/* Title */}
        <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight">
          Link Not Found
        </h1>

      
        {/* Attempted Code Badge */}
        {/* {code && (
          <div className="mt-5 inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gray-100 dark:bg-gray-700/60 border border-gray-200 dark:border-gray-600 text-xs font-mono font-medium text-gray-700 dark:text-gray-200">
            <span>Requested Code:</span>
            <span className="font-bold text-red-500 dark:text-red-400">{code}</span>
          </div>
        )} */}

        {/* Action Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/")}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl border border-gray-300 dark:border-gray-600 text-xs font-semibold text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors shadow-xs"
          >
            <ArrowLeftIcon className="w-4 h-4" />
            Go Back
          </button>
          <button
            onClick={() => (window.location.href = "/")}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-[#3a57e8] hover:bg-[#2b44cb] text-white text-xs font-semibold shadow-md shadow-blue-500/20 cursor-pointer transition-all duration-150"
          >
            <HomeIcon className="w-4 h-4" />
            Go to Homepage
          </button>
        </div>

        {/* Footer Note */}
        <p className="mt-8 text-[11px] text-gray-400 dark:text-gray-500 font-medium">
          Error 404 &bull;
        </p>
      </div>
    </div>
  );
}
